import React from 'react';
import {
  UPGRADE_FEATURE_GROUPS,
  UPGRADE_TESTIMONIALS,
} from '../constants';
import styles from '../Settings.module.css';

interface SettingsUpgradeModalProps {
  onClose: () => void;
  onStartTrial: () => void;
  loading?: boolean;
  error?: string | null;
}

const SettingsUpgradeModal: React.FC<SettingsUpgradeModalProps> = ({
  onClose,
  onStartTrial,
  loading = false,
  error = null,
}) => (
  <div className={`${styles.modalBackdrop} ${styles.upgradeBackdrop}`} onClick={onClose}>
    <div
      className={`${styles.modalCard} ${styles.upgradeModalCard}`}
      onClick={(event) => event.stopPropagation()}
    >
      <button type="button" onClick={onClose} className={styles.closeButton}>
        ×
      </button>

      <div className={styles.upgradeHero}>
        <h2 className={styles.upgradeTitle}>Upgrade to XPSR Pro</h2>
        <p className={styles.upgradeSubtitle}>Unlock your full potential</p>
      </div>

      <div className={styles.upgradePricingCard}>
        <div className={styles.upgradePricingHeader}>
          <div className={styles.upgradePrice}>
            $4.99
            <span className={styles.upgradePriceSuffix}>/month</span>
          </div>
          <div className={styles.upgradePriceMeta}>Cancel anytime • 14-day free trial with card on file</div>
        </div>

        <button
          type="button"
          onClick={onStartTrial}
          className={`${styles.primaryButton} ${styles.upgradeTrialButton}`.trim()}
          disabled={loading}
        >
          {loading ? 'Redirecting...' : 'Start Free Trial'}
        </button>

        {error ? <p className={styles.appearanceErrorText}>{error}</p> : null}

        <div className={styles.upgradeTrialMeta}>Your card is collected now and billed only if the trial continues.</div>
      </div>

      <div className={styles.upgradeFeaturesGrid}>
        {UPGRADE_FEATURE_GROUPS.map((group) => (
          <div key={group.title}>
            <h4 className={styles.upgradeFeatureTitle}>{group.title}</h4>
            <ul className={styles.upgradeFeatureList}>
              {group.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className={styles.testimonialsPanel}>
        <h4 className={styles.testimonialsTitle}>What Pro Users Say</h4>
        <div className={styles.testimonialsGrid}>
          {UPGRADE_TESTIMONIALS.map((testimonial) => (
            <div key={testimonial.author} className={styles.testimonialQuote}>
              {testimonial.quote}
              <div className={styles.testimonialAuthor}>{testimonial.author}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(SettingsUpgradeModal);
